<!--
 * @Descripttion: 
 * @version: 
 * @Author: mrh
 * @Date: 2020-07-31 09:24:18
 * @LastEditors: mrh
 * @LastEditTime: 2021-03-01 17:12:18
--> 
<template>
  <section class="sec_chostype">
    <!--左侧导航栏  -->
    <van-sidebar
      v-model="checkIndex"
      class="sideBars"
      @change="swiperType(checkIndex)"
    >
      <van-sidebar-item
        v-for="(item, idx) in listDatas[0].cateList"
        :key="idx"
        :title="item.cateName"
        @click="changeType(item.cateId)"
      ></van-sidebar-item>
    </van-sidebar>

    <!-- 右侧列表 -->
    <div class="goodsList" v-show="!showNulls">
      <!-- 三级分类头部 -->
      <div class="side_item_head" v-show="!showThree" @touchmove.stop>
        <van-tabs
          v-model="threeIndex"
          @change="getGoodsList(threeIndex)"
          title-inactive-color="#1D1D1D"
          title-active-color="#FFFFFF"
          :ellipsis="false"
          swipe-threshold="2"
        >
          <van-tab
            v-for="(items, indexs) in listDatas[0].list"
            :key="indexs"
            :title="items.cateName"
            :name="indexs"
          ></van-tab>
        </van-tabs>
      </div>
      <i
        class="iconfont pro icon-home_location_icon_d"
        @click="showPopups"
        v-show="!showThree"
      ></i>
      <!-- 全部分类下拉弹窗 -->
      <van-popup v-model="showThree">
        <p>
          <span>全部分类</span>
          <i
            class="iconfont alltype icon-home_location_icon_u"
            @click="showPopups"
          ></i>
        </p>
        <div class="pupList">
          <span
            v-for="(items, idx) in listDatas[0].list"
            :key="idx"
            @click="getGoodsList(idx)"
            :class="{ bgcol1: idx == threeIndexs, bgcol2: idx != threeIndexs }"
            >{{ items.cateName }}</span
          >
        </div>
        <!-- :class="{bgcol1:idx == tabs.threeIndex,bgcol2:idx != tabs.threeIndex}" -->
      </van-popup>
      <goods-list :list-data="goodsLists" ref="goodslist">
        <!-- <template v-slot:search="{ item }">
          
        </template> -->
        <template v-slot:tj="{ item }">
          <div class="btn_group">
            <van-button
              color="#208FFF"
              @click.stop="getGoodsDesc(item.spgExId)"
              class="copy"
              v-if="item.spgExId!=0"
              >复制推广文案</van-button
            >
            <van-button
              round
              block
              type="info"
              color="#FF9A34"
              @click.stop="
                recommendAdd(item.isRecommend, item.spgId)
              "
              :class="{ isRecommend: item.isRecommend == 1 }"
              >{{ item.isRecommend == 1 ? "取消推荐" : "推荐" }}</van-button
            >
          </div>
        </template>
        <template v-slot:recommend="{ item }">
          <div >
            <p>
              <span>¥{{ item.price }}</span>
              <span>{{ item.guidePrice }}</span>
              <span class="shopMoney" v-if='item.shareMoney>0'>佣金{{ item.shareMoney }}</span>
            </p>
          </div>
        </template>
      </goods-list>
    </div>

    <div id='copy-txt' v-html="description"></div>
    <!-- <no-goods :shows="tabs.showNulls" /> -->
  </section>
</template>

<script>
import goodsList from "@/components/list/list";
import { recommendAdd, getGoodsDesc } from "@/api/join";
export default {
  components: {
    goodsList,
    // noGoods
  },
  name: "sideBarList",
  props: {
    swiperWidth: {
      // 左侧菜单的宽度 单位px
      default: "100",
      type: Number | String,
    },
    listDatas: {
      default: function () {
        return [];
      },
      type: Array,
    },
    dot: {
      // 右侧红点
      default: false,
      type: Boolean,
    },
    info: {
      // 右侧计数角标
      default: "",
      type: Number | String,
    },
    swipeThreshold: {
      // 滚动阈值，标签数量超过阈值时开始横向滚动
      default: 3,
      type: Number | String,
    },
    ellipsis: {
      //是否省略过长的标题文字
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      // checkIndex: 0,//左侧边栏分类的index
      // goodsData: [],
      // list: [],
      // threesList: [],
      // goodsList: [],
      // threeIndex: 0, //右侧头部分类的index
      showThree: false,
      tabIndex: 0, //type的index
      tabDatas: [],
      isTop: false,
      isBottom: false,
      checkIndex: 0,
      showNulls: false,
      threeIndex: "",
      threeIndexs: 0,
      cateId: "",
      description: ""
    };
  },
  methods: {
    swiperType(idx) {},
    changeType(id) {
      this.threeIndexs = 0;
      this.cateId = id;
      this.$store.commit("user/SET_cateId", id);
      this.$store.commit("user/SET_isRecommend", true);
      this.$refs.goodslist.$refs.scrolls.scrollTo(0, 0);
    },

    // 点击三级分类切换商品列表
    getGoodsList(idx) {
      // console.log(idx);
      this.threeIndexs = idx;
      this.threeIndex = idx;
      this.showThree = false;
      this.$refs.goodslist.$refs.scrolls.scrollTo(0, 0);
    },

    // 更多的方法
    pro(idx) {
      this.gooslistIndex = idx;
    },

    // 是否显示三级分类的弹窗
    showPopups: function () {
      this.showThree = !this.showThree;
      //   this.commits("showThree", this.tabDatas[this.tabIndex].showThree);
    },
    recommendAdd(type, id) {
      if (this.$store.getters.states == "4") {
        this.$toast("您已被冻结");
        return;
      }
      let obj = {
        sellerProductGoodsId: id, //sellerProductGoodsId
        isRec: type == 0 ? "1" : "0", //1推荐， 0取消推荐
      };
      recommendAdd(obj).then((res) => {
        if (res.appStatus.errorCode == 0) {
          this.$store.commit(
            "user/SET_cateId",
            this.cateId ? this.cateId : this.listDatas[0].cateList[0].cateId
          );
          this.$store.commit("user/SET_isRecommend", true);
          this.$toast(type == 0 ? "推荐成功" : "已取消推荐");
        }
      });
    },
    getGoodsDesc(spgExId) {
      getGoodsDesc({
        spgExId, //商品推广文案的id
      }).then((res) => {
        if (res.appStatus.errorCode == 0) {
          this.description = ''
          this.description = res.content.description;
          setTimeout(() => {
            this.copyTXT();
          }, 200);
        }
      });
    },

    copyTXT() {
      window.getSelection().removeAllRanges(); // 移除选中的元素
      var copyDOM = document.querySelector("#copy-txt"); //指定的DOM元素
      var range = document.createRange(); // 创建容器
      range.selectNode(copyDOM); // 选中需要复制的节点
      window.getSelection().addRange(range); // 执行选中元素
      var successful = document.execCommand("copy"); // 执行 copy 操作
      try {
        var msg = successful ? "复制成功" : "复制失败";
        // console.log("Copy was " + msg);
        this.$toast(msg)
      } catch (err) {
        // console.log("unable to copy");
      }
    },
  },
  mounted() {
    // console.log(this.listDatas)
    // 动态更新sidebar的宽度
    // setTimeout(() => {
    //   document
    //     .getElementsByClassName("sideBars")[0]
    //     .style.setProperty("--width-length", this.swiperWidth + "px");
    //   document
    //     .getElementsByClassName("sideBars")[1]
    //     .style.setProperty("--width-length", this.swiperWidth + "px");
    // }, 500);
    //console.log(this.goodsMsgForm.logo)
    //
  },
  computed: {
    goodsLists() {
      return this.listDatas[0].list.length > 0
        ? this.listDatas[0].list[this.threeIndexs].list
        : [];
    },
  },
};
</script>

<style lang="scss" scoped>
$widths: (
  length: 80px,
);
.sec_chostype {
  @each $name, $width in $widths {
    --width-#{$name}: $width;
  }
}

@function width($width-name) {
  @return var(--width-#{$width-name});
}

.sec_chostype {
  width: 100%;
  height: calc(100% - 44px);
  margin-top: 50px;
  display: flex;
  /deep/.tabs {
    width: 100%;
    height: calc(100vh - 44px);
    /deep/.van-sticky {
      [class*="van-hairline"]::after {
        border: none;
      }
      .van-tab__text--ellipsis {
        font-size: 18px;
      }
      .van-tab--active {
        font-weight: bold;
      }
      .van-tabs__wrap {
        height: 50px;
        .van-tab {
          line-height: 50px;
        }
      }
    }
    > div:nth-child(2) {
      width: 100%;
      height: 100%;
      margin-top: 10px;
      overflow-y: auto;
      overflow-x: hidden;
    }
  }
}

.sideBars {
  width: 80px;
  height: calc(100vh - 44px);
  background: #f5f5f5;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  .van-sidebar-item {
    width: 80px;
    height: 50px;
    // border-left: 0;
    white-space: nowrap;
    font-size: 14px;
    // background: #f5f5f5;
    // padding: 0 11.8px;
    display: flex;
    align-items: center;
    text-align: left;
    color: #666;
    .van-sidebar-item__text {
      width: 64.4px;
    }
    // .van-info {
    //   background-color: #ff1929;
    // }
  }
  .van-sidebar-item--select::before {
    width: 3px;
    height: 25px;
    background-color: #FF9A34;
    border-radius: 0px 3px 3px 0px;
  }
  .van-sidebar-item--select {
    // background: #fff;
    // border-bottom: 1.04px solid #0b853c;
    // color: #0b853c;
    font-weight: bold;
  }
}
.goodsList {
  width: auto;
  height: calc(100vh - 44px);
  flex: 1;
  overflow: hidden;
  .side_item_head {
    width: 240px;
    height: 40px;
    // display: flex;
    // align-items: center;
    // overflow: auto;
    // white-space: nowrap;
    // border-bottom: 1.04px solid #dcdcdc;
    position: fixed;
    background: #fff;
    z-index: 99;
    .van-tabs__wrap {
      height: 40px;
    }
    .van-tabs__nav {
      padding-bottom: 0;
    }
    .van-tabs__line {
      display: none !important;
    }
    .van-tab--active {
      font-weight: bold;
    }
    .van-tab--complete {
      font-size: 15px;
    }
    [class*="van-hairline"]::after {
      border: none;
    }
    /deep/.van-tab {
      padding: 0 12.4px;
    }
    i {
      font-size: 16px;
    }
    .col1 {
      color: #0b853c;
    }
    .col2 {
      color: #666;
      font-weight: 100;
    }
  }
  .pro {
    line-height: 40px;
    position: fixed;
    padding: 0 5px;
    height: 40px;
    background: #fff;
    font-size: 18px;
    right: 0;
    color: #dcdcdc;
    // border-bottom: 1.04px solid #dcdcdc;
    z-index: 99;
  }
  .icon-icon_arrowDownGray:before {
    border-left: 1.04px solid #dcdcdc;
    padding: 0 15px;
  }
  .van-popup--center {
    top: 44px;
    width: 275px;
    height: auto;
    padding: 10px;
    right: 0px;
    left: auto;
    transform: none;
    p {
      width: 100%;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #1d1d1d;
      margin-bottom: 5px;
      span {
        font-size: 15px;
        font-weight: bold;
      }
      i {
        display: inline-block;
        margin-top: 0;
      }
      .icon-icon_arrowU:before {
        border-left: 1.04px solid #dcdcdc;
        padding: 0 15px;
      }
    }
    .pupList {
      width: 100%;
      height: auto;
      display: flex;
      flex-wrap: wrap;
      overflow: hidden;
      span {
        width: 84px;
        height: 27px;
        background: #f5f5f5;
        border-radius: 2px;
        font-size: 15px;
        line-height: 27px;
        text-align: center;
        margin: 0 0 10px 9px;
        text-overflow: ellipsis;
        overflow: hidden;
        border-radius: 13px;
        font-weight: bold;
      }
      span:nth-child(3n + 1) {
        margin-left: 0;
      }
      .bgcol1 {
        background: #FDF6EC;
        color: #FF9900;
      }
      .bgcol2 {
        background: #F8F8F8;
        color: #333;
      }
    }
  }
}
.goods_null {
  width: 100%;
  height: auto;
  img {
    width: 160px;
    height: 160px;
    display: block;
    margin: 147px auto 0;
  }
  p {
    color: #0b853c;
    font-size: 17px;
  }
  .van-button--normal {
    width: 195px;
    height: 49px;
    line-height: 49px;
    border-radius: 5px;
    font-weight: bold;
    font-size: 17px;
    margin-top: 15px;
  }
}
/deep/.glist {
  margin-top: 40px;
  height: calc(100% - 96px);
  padding: 0 8px;
  background: #F6F6F6;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  > div {
    border-radius: 0;
    border-bottom: 1.04px solid #f0f0f0;
    margin-top: 8px;
    border-radius: 8px;
    .van-image__img {
      width: 75px;
      height: 75px;
      margin-right: 6px;
      flex: 1;
      border-radius: 5px 0px 0px 5px;
    }
  }
  .gtexts {
    width: 35px;
    margin: 0 auto;
  }
}
.btn_group {
  display: flex;
  .van-button {
    padding: 0;
    border: 1.5px solid rgba(255, 81, 78, 1);
    border-radius: 25px;
  }
  .copy {
    width: 99px;
    height: 26px;
    margin-left: 6px;
  }
}

#copy-txt {
  position:absolute;
  top:-999em;
  white-space: pre;
}
</style>